import { shuffleArray } from "./_shuffleArray";

const { $, EventEmitter } = window;

const { Swiper, Navigation, Pagination } = window.swiper;

export default class HomeApp {
  constructor(emitter) {
    this.pickupSnaps();
    this.setupHomeEexcerptArticlePickupSlider();
    this.setupHomeEexcerptSnapSlider();
    this.setupEvents();
  }

  // eslint-disable-next-line class-methods-use-this
  pickupSnaps() {
    const availablesElement = document.querySelector(
      ".p-home__snap-themes--availables"
    );
    if (!availablesElement) {
      throw new Error("availablesElement is null");
    }
    const availableThemes = Array.from(
      availablesElement.querySelectorAll(".p-home__snap-theme")
    );
    const targetElement = document.querySelector(
      ".p-home__snap-themes--picked"
    );
    if (!targetElement) {
      throw new Error("targetElement is null");
    }

    const shuffledThemes = shuffleArray(availableThemes);

    const SELECT_QTY = 2;
    for (let i = 0; i < SELECT_QTY; i += 1) {
      if (i < shuffledThemes.length) {
        const theme = shuffledThemes[i];
        targetElement.appendChild(theme);

        const imgList = theme.querySelectorAll("img");
        // eslint-disable-next-line no-restricted-syntax
        for (const img of imgList) {
          img.src = img.dataset.src;
        }
      }
    }
    while (availablesElement.firstChild) {
      availablesElement.removeChild(availablesElement.firstChild);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  setupHomeEexcerptArticlePickupSlider() {
    if ($(".p-home__excerpt-articles-pickup-slider").length) {
      const homeExcerptArticlesPickupSlider = new Swiper(
        ".p-home__excerpt-articles-pickup-slider",
        {
          loop: true,
          loopAdditionalSlides: 10,
          loopedSlidesLimit: false,
          centeredSlides: true,
          grabCursor: true,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        }
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  setupHomeEexcerptSnapSlider() {
    if ($(".p-home__snap-theme-slider").length) {
      const homeEexcerptSnapSlider = new Swiper(".p-home__snap-theme-slider", {
        loop: true,
        centeredSlides: true,
        grabCursor: true,
        loopedSlides: 10,
        loopedSlidesLimit: false,
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 500,
          modifier: 1,
          slideShadows: false,
        },

        breakpoints: {
          320: {
            slidesPerView: 1.2,
            // spaceBetween: 0,
            // width: 616,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: "auto",
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  toggleHeaderClass(flag) {
    if (flag) {
      $(".l-header").addClass("is-scrolled");
    } else {
      $(".l-header").removeClass("is-scrolled");
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onScroll() {
    const scrollTop = $(window).scrollTop();
    if (scrollTop >= 10) {
      this.toggleHeaderClass(true);
    } else {
      this.toggleHeaderClass(false);
    }
  }

  setupEvents() {
    const { emitter } = this;

    $(window).on("scroll", () => {
      this.onScroll();
    });
  }

  static load() {
    const promises = [];
    return Promise.all(promises);
  }
}
